import { Component, Event, EventEmitter, Listen, Prop, State, h } from '@stencil/core';
import { Customer } from '../../../globals/customer';
import { objectHasValues, ErrorHelper } from '../../../helpers';
import { updateLeaseApplication } from '../../../utils';
import { IncomeTranslation } from '../../../globals/translations';

@Component({
  tag: 'income-info-state',
  styleUrl: './state-styles/income-info-state.scss',
  shadow: false,
})
export class IncomeInfoState {
  @State() isLoading = false;

  @Prop({ mutable: true }) incomeInfo: Customer['incomeInfo'];
  @Prop({ mutable: true }) errors: ErrorHelper;
  @Prop() translation: Partial<IncomeTranslation>;

  @Event() updateCustomer: EventEmitter<Partial<Customer>>;
  @Event() continueClick: EventEmitter;

  @Listen('updateIncomeInfo', { target: 'body' })
  async getUpdatedIncome(event: CustomEvent) {
    if (event.detail) {
      const { monthlyIncome, lastPayDay, nextPayDay, payFrequency } = event.detail;
      const toUpdate = { incomeInfo: { ...this.incomeInfo } } as Partial<Customer>;

      if (monthlyIncome !== this.incomeInfo.monthlyGross) {
        toUpdate.incomeInfo.monthlyGross = monthlyIncome;
        this.incomeInfo.monthlyGross = monthlyIncome;
      }

      if (lastPayDay !== this.incomeInfo.lastPayDate) {
        toUpdate.incomeInfo.lastPayDate = lastPayDay;
        this.incomeInfo.lastPayDate = lastPayDay;
      }

      if (nextPayDay !== this.incomeInfo.nextPayDate) {
        toUpdate.incomeInfo.nextPayDate = nextPayDay;
        this.incomeInfo.nextPayDate = nextPayDay;
      }

      if (payFrequency !== this.incomeInfo.frequency) {
        toUpdate.incomeInfo.frequency = payFrequency;
        this.incomeInfo.frequency = payFrequency;
      }

      if (objectHasValues(this.incomeInfo)) {
        try {
          this.isLoading = true;
          await updateLeaseApplication({ incomeInfo: toUpdate.incomeInfo });
          this.updateCustomer.emit({ incomeInfo: { ...this.incomeInfo } });
          this.continueClick.emit();
        } catch (error) {
          this.errors.hasGenericError = true;
        }
        this.isLoading = false;
      }
    }
  }

  render() {
    return (
      <pc-monthly-income {...this.incomeInfo} isLoading={this.isLoading} translation={this.translation}>
        {this.errors.hasGenericError && <pc-generic-error slot="error-card" />}
      </pc-monthly-income>
    );
  }
}
